export function resetSelectors(state) {
    return state.reset;
  }